import React from 'react';
import { Outlet } from 'react-router-dom';
export { default as districtRoutes } from './routes';

export default function () {
  return <Outlet />;
}
